<template>
  <q-dialog :value="open" @hide="closeDialog">
    <q-card style="min-width: 300px" v-if="open">
      <q-card-section class="text-center">
        <div class="text-h6 text-weight-medium">Enter RingCentral Password</div>
      </q-card-section>
      <q-separator />
      <q-card-section>
        <app-editable-input
          :data="password"
          text="Password *"
          name="password"
          type="password"
          @input="
            password = $event.model;
            delayTouch($v.password, $options.touchMap);
          "
          :error="$v.password.$error"
        />
      </q-card-section>
      <q-separator />
      <q-card-actions align="right">
        <q-btn
          label="Save"
          color="primary"
          @click="handleSave"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import AppEditableInput from '@client/components/form/editable-input';

export default {
  components: {
    AppEditableInput
  },
  validations: {
    password: { required }
  },
  data() {
    return {
      open: false,
      password: '',
      callback: () => {}
    };
  },
  methods: {
    openDialog(callback) {
      this.$v.$reset();
      this.open = true;
      this.password = '';
      this.callback = callback;
    },
    closeDialog() {
      this.open = false;
    },
    handleSave() {
      this.validate(['password']);
      this.closeDialog();
      this.callback(this.password);
    }
  }
};
</script>

<style>

</style>
